import { Component, ElementRef, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Animations } from '@motes-sdk/animations';

@Component({
    selector: 'drop-down-options',
    templateUrl: './drop-down-options.component.html',
    styleUrls: ['./drop-down-options.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.fadeIn(100)]
})
export class DropDownOptionsComponent implements OnInit {

    @Input() isShown: boolean = false;

    constructor(private eRef: ElementRef) { }

    ngOnInit(): void { }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if(this.eRef.nativeElement.children[0].contains(event.target)) {
            this.isShown = !this.isShown;
        } else {
            if(this.isShown) {
                this.isShown = false;
            }
        }
    }


}
